module.exports = __webpack_public_path__ + "static/media/mcdonals-logo-white.043497b4.png";